import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

import { Accessibility } from 'services/accessibility';
import { GtpPassCountry } from 'my-account/constants';
import { CountryStatus } from 'international/constants';

import { CmsInternationalCalling } from 'store/cms/models';
import { InternationalRate } from 'store/international-rates/models';

interface ResultData {
    header: string;
    footer: string;
    description?: string;
    ctaToAddPass?: string;
    talkAndText?: TalkMsgData[];
}

@Component({
    selector: 'xm-call-rates-details',
    styleUrls: ['./call-rates-details.scss'],
    templateUrl: './call-rates-details.html',
    standalone: false
})
export class XmCallRateDetails implements OnChanges {

    @Input() public pageData: CmsInternationalCalling;
    @Input() public rateDetails: InternationalRate;
    @Input() public mexCanData: CmsSearchData;
    @Input() public isInternationalSearch: boolean;

    @Output() public mexCanLauncher: EventEmitter<void> = new EventEmitter<void>();

    public countryFound: boolean = false;
    public showCoverageNotAvailable: boolean;
    public selectedCountryDetails: InternationalRate;
    public resultData: ResultData;
    public isMexCan: boolean = false;

    private currencyPipe: CurrencyPipe;
    private accessibility: Accessibility;

    constructor(accessibility: Accessibility, currencyPipe: CurrencyPipe) {
        Object.assign(this, { accessibility, currencyPipe });
    }

    public ngOnChanges(): void {
        this.showCoverageNotAvailable = false;
        if (this.rateDetails) {
            this.countryFound = true;
            this.accessibility.announceReaderText(this.pageData.callRatesReaderText.replace(/\[COUNTRY\]/g, this.rateDetails.displayName));

            if (this.rateDetails.status === CountryStatus.BLACKLISTED) {
                this.showCoverageNotAvailable = true;
                this.resultData = this.createResultDataByCountry(this.pageData.blackListedCountryData, this.rateDetails.displayName);
            } else {
                this.selectedCountryDetails = this.rateDetails;
                if ((this.selectedCountryDetails.displayName.toUpperCase() === GtpPassCountry.MEXICO || this.selectedCountryDetails.displayName.toUpperCase() === GtpPassCountry.CANADA) && this.mexCanData) {
                    this.resultData = this.createResultDataByCountry(this.mexCanData, this.rateDetails.displayName, this.rateDetails);      
                } else {
                    this.isMexCan = this.rateDetails.displayName.toUpperCase() === GtpPassCountry.MEXICO || this.rateDetails.displayName.toUpperCase() === GtpPassCountry.CANADA;
                    this.resultData = this.createResultDataByCountry(this.isMexCan ? this.pageData.canMexData : this.pageData.otherCountryData, this.rateDetails.displayName, this.rateDetails);
                }
            }
            // No country found
        } else {
            this.countryFound = false;
            this.resultData = this.pageData.initialSearchData;
        }
    }

    public addAddon(): void {
        this.mexCanLauncher.emit();
    }

    private createResultDataByCountry(countryData: ResultData, countryName?: string, detail?: InternationalRate): ResultData {
        return {
            header: countryData.header,
            footer: countryData.footer.replace('[COUNTRY]', countryName),
            description: countryData.description && countryData.description.replace('[COUNTRY]', countryName),
            ctaToAddPass: countryData.ctaToAddPass || '',
            ...(detail && detail.rates && {
                talkAndText: this.isMexCan ? [
                    {
                        header: this.pageData.talkData.header,
                        rate: (detail.rates.ildMinutes || detail.rates.ildMinutes === 0) ? this.currencyPipe.transform(detail.rates.ildMinutes) : 'Unavailable',
                        unit: this.pageData.talkData.unit
                    }
                ] : [
                    {
                        header: this.pageData.talkData.header,
                        rate: (detail.rates.ildMinutes || detail.rates.ildMinutes === 0) ? this.currencyPipe.transform(detail.rates.ildMinutes) : 'Unavailable',
                        unit: this.pageData.talkData.unit
                    },
                    {
                        header: this.pageData.msgData.header,
                        rate: this.pageData.msgData.rate,
                        unit: this.pageData.msgData.unit
                    }
                ]
            })
        };
    }
}
